import { BpLink } from '../../../../shared/components/text/link/BpLink'
import React from 'react'

interface TopKeywordCellProps {
  top_keyword: string
  project_id: number | string
}

export const TopKeywordCell = ({ top_keyword, project_id }: TopKeywordCellProps) => {
  return <BpLink to={`ads-keyword/${project_id}/${top_keyword}`}>{top_keyword}</BpLink>
}
